var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-slogan"},[(_vm.data.text)?_c('div',{staticClass:"section-slogan__title",domProps:{"innerHTML":_vm._s(_vm.data.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }